var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952v51.385c0 4.785-3.879 8.664-8.664 8.664h-53.427c-4.785 0-8.664-3.879-8.664-8.664v-70.673c.001-4.785 3.879-8.664 8.664-8.664h35.784z",
    fill: "#e03303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952h-20.531c-3.19 0-5.776-2.586-5.776-5.776v-22.176z",
    fill: "#e9714f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.351 65.894v5.855h-4.157v-17.249h6.881c1.32 0 2.487.243 3.503.728s1.799 1.179 2.358 2.076c.553.897.835 1.912.835 3.051 0 1.681-.604 3.023-1.811 4.033-1.201 1.004-2.854 1.506-4.958 1.506zm0-3.21h2.724c.807 0 1.421-.197 1.844-.604.423-.4.632-.97.632-1.703 0-.807-.22-1.45-.654-1.935-.434-.479-1.027-.722-1.777-.733h-2.769z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.138 65.894v5.855h-4.157v-17.249h6.881c1.32 0 2.487.243 3.503.728 1.015.485 1.799 1.179 2.358 2.076.553.897.835 1.912.835 3.051 0 1.681-.604 3.023-1.811 4.033-1.201 1.004-2.854 1.506-4.958 1.506zm0-3.21h2.724c.807 0 1.421-.197 1.844-.604.423-.4.632-.97.632-1.703 0-.807-.22-1.45-.654-1.935-.434-.479-1.027-.722-1.777-.733h-2.769z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.312 57.709h-5.172v14.039h-4.163v-14.039h-5.077v-3.209h14.411v3.209z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.96a5f610b16f354886fad58514b6eeb7.svg";
export { ForwardRef as ReactComponent };